import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqItems } from '@/mocks/gossip';

export default function HomeFaq() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.35fr] lg:gap-12">
        <Reveal>
          <SectionHeading
            eyebrow="FAQ"
            title="新来的朋友常问这些"
            desc="如果这里没有你要的答案，欢迎直接给我们发邮件，通常一天内会回。"
          />
          <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="font-heading text-sm font-bold text-foreground-950">还有其他疑问？</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">
              投稿、更正、合作，都可以通过邮箱联系。我们更希望收到「这条材料不对」这种具体反馈。
            </p>
            <a
              href="mailto:contact@baoliaochigua.com"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              contact@baoliaochigua.com
            </a>
            <div className="mt-5 border-t border-background-100 pt-4">
              <Link
                to="/community"
                className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-secondary-700 transition-colors hover:text-secondary-800"
              >
                或者直接去讨论区问
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <FaqAccordion items={faqItems} />
        </Reveal>
      </div>
    </section>
  );
}